import { useCallback, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import {
  useUpdate,
  useNotify,
  SimpleForm,
  TextInput,
  useResourceContext,
  required,
  choices,
  useRefresh,
  Edit,
  RadioButtonGroupInput,
  useRecordContext,
} from "react-admin";
import { useFormContext } from "react-hook-form";
import SaveDeleteBtns from "../../saveDeleteBtns/SaveDeleteBtn";
import CorrectionProductForm from "../components/CorrectionProductForm";

const validateType = [
  required(),
  choices(["adj"], "Please choose one of the values"),
];
const validateCategory = [required()];
const validateNote = [required()];

function NormalizeCorrectionRecord() {
  const record = useRecordContext();
  const { setValue } = useFormContext();

  useEffect(() => {
    const items = (record?.product_adjs || []).filter((item) => item.mutation !== 0);
    if (!items.length) return;
    setValue("category", items[0].mutation < 0 ? "-" : "+");
    setValue(
      "product_adjs",
      items.map((item) => ({
        product_id: item.product_id,
        amount: Math.abs(item.mutation),
      }))
    );
  }, [record, setValue]);

  return null;
}

export default function CorrectionEditDialog({ open, setOpen, recordId }) {
  const [update] = useUpdate();
  const notify = useNotify();
  const refresh = useRefresh();
  const resource = useResourceContext(); // cuman nama resource
  const save = useCallback(
    async (values) => {
      try {
        await update(
          resource,
          { id: values.id, data: values },
          {
            returnPromise: true,
            onSuccess: (data) => {
              notify("ra.notification.updated", {
                messageArgs: { smart_count: 1 },
              });
              setOpen(false);
              refresh();
            },
          }
        );
      } catch (error) {
        if (error.body.errors) {
          // The shape of the returned validation errors must match the shape of the form
          return error.body.errors;
        }
      }
    },
    [update]
  );

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} keepMounted={false}>
      <Edit
        title={" "}
        id={recordId}
        actions={false}
        sx={{ "& .RaEdit-main": { mt: 0 } }}
      >
        <SimpleForm
          warnWhenUnsavedChanges
          onSubmit={save}
          toolbar={<SaveDeleteBtns />}
          mode="onBlur"
          reValidateMode="onBlur"
        >
          <NormalizeCorrectionRecord />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pt: 0,
            }}
          >
            <DialogTitle>Edit Correction</DialogTitle>
            <IconButton onClick={handleClose} sx={{ mr: "11px" }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <DialogContent>
            <TextInput disabled source="id" sx={{ display: "none" }} />

            <CorrectionProductForm />

            <TextInput
              disabled
              source="type"
              defaultValue="adj"
              sx={{ display: "none" }}
              validate={validateType}
            />

            <RadioButtonGroupInput
              source="category"
              choices={[
                { id: "-", name: "Kurangi" },
                { id: "+", name: "Tambah" },
              ]}
              validate={validateCategory}
              row={false}
            />
            {/* <SelectInput
              variant="outlined"
              source="type"
              choices={[
                { id: "in", name: "Masuk" },
                { id: "out", name: "Keluar" },
                { id: "adj", name: "Penyesuaian" },
              ]}
              fullWidth
              isRequired
              validate={validateType}
            /> */}

            <TextInput
              variant="outlined"
              source="note"
              fullWidth
              multiline
              minRows={3}
              maxRows={3}
              validate={validateNote}
            />
          </DialogContent>
        </SimpleForm>
      </Edit>
    </Dialog>
  );
}
